import { cx } from '@linaria/core';
import { PostloadedImage } from '@utils/react';
import { backgroundBlurredImage, svg, wrapper } from './atom.frontpage-graphic.style.js';
import { ReliefSVG } from './atom.relief-svg.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FrontpageGraphic(props) {
  return /*#__PURE__*/jsxs("div", {
    className: cx(wrapper, props.className),
    children: [props.blurredBackgroundImageSrc && /*#__PURE__*/jsx(PostloadedImage, {
      className: backgroundBlurredImage,
      src: props.blurredBackgroundImageSrc,
      sizes: "100vw",
      alt: "",
      role: "presentation"
    }), /*#__PURE__*/jsx(ReliefSVG, {
      className: svg,
      position: "top"
    })]
  });
}

export { FrontpageGraphic };
//# sourceMappingURL=atom.frontpage-graphic.js.map
